var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('m-datatable',{attrs:{"showExportBtns":false,"showSelect":false,"headers":_vm.headers,"items":_vm.items,"filters":_vm.filters},on:{"update:filters":function($event){_vm.filters=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }